import $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-loading-skeleton/dist/skeleton.css";
import React, { Suspense, useEffect } from "react";
import { Helmet } from "react-helmet";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { refresh_token } from "./API/setupAxios";
import "./App.scss";
import { getGeneralDetails } from "./Redux/GeneralDetailsSlice";
import MainRoutes from "./Routing/Routes";
import AuthInit from "./components/auth/Redux/AuthInit";
import config from "./config";
import { I18nProvider } from "./i18n/i18nProvider";
import Loader from "./sharedComponents/Loader";
import ScrollToTop from "./sharedComponents/ScrollToTop/ScrollToTop";
import { getNavigationMenu } from "./Redux/NavigationMenuSlice";

export const useLocal = () => {
  let ls = localStorage.getItem("i18nConfig");
  if (ls) {
    try {
      return JSON.parse(ls).selectedLang;
    } catch (error) {
      throw error;
    }
  }
};

export let isRefreshingRef = false;
export let refreshPromiseRef = null;

function App() {
  const contactId = useSelector(
    (state) => state?.auth?.user?.personalInformation?.id
  );
  const user_sign_In = useSelector(
    (state) =>
      state.generalDetails.generalDetails?.general_settings?.user_sign_In
  );

  const clientDetails_id = sessionStorage.getItem("clientDetails_id");

  const dispatch = useDispatch();
  // const lang = useLang();
  useEffect(() => {
    dispatch(getGeneralDetails());
    setTimeout(() => {
      if (user_sign_In && user_sign_In !== "yes") {
        dispatch(getNavigationMenu());
      }
    }, 1000);

    return () => clearTimeout(1000);
  }, [dispatch]);

  // this code calls refreshToekn every 14 minutes
  useEffect(() => {
    const getTokens = async () => {
      if (contactId && clientDetails_id) {
        let res = await refresh_token();
        if (res.data.access_token && res.data.refresh_token) {
          sessionStorage.setItem("accessToken", res.data.access_token);
          localStorage.setItem(
            `${config.APP_NAME}_refreshToken`,
            res.data.refresh_token
          );

          isRefreshingRef = false;
          refreshPromiseRef = null;
        }
      }
    };

    const refreshTokens = () => {
      if (!isRefreshingRef) {
        isRefreshingRef = true;
        refreshPromiseRef = new Promise(async (resolve) => {
          await getTokens();
          resolve();
        });
      }
      return refreshPromiseRef;
    };

    refreshTokens();

    let interval = setInterval(refreshTokens, 14 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>{config.APP_NAME}</title>
      </Helmet>
      <I18nProvider>
        <BrowserRouter>
          <div className="App">
            <AuthInit>
              <Suspense fallback={<Loader />}>
                <ToastContainer />
                <MainRoutes />
                <ScrollToTop />
              </Suspense>
            </AuthInit>
          </div>
        </BrowserRouter>
      </I18nProvider>
    </>
  );
}

export default App;
